import AllMailContainer from '../../containers/allMail/allMailContainer';

export default function AllMail() {
  return <AllMailContainer />;
}
